import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Same helper the apps keep in `lib/utils` — a package can't reach into an app. */
export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}
